import React, { Component } from 'react';

// const propTypes = {
//   onSkip: PropTypes.func,
//   onLinkClick: PropTypes.func,
//   duration: PropTypes.number,
//   skipOn: PropTypes.number,
//   URL: PropTypes.string,
// };


export default class AdControllers extends Component {
  constructor(props) {
    super(props);

    this.adsActionsTitle = {
      readMore: 'بیشتر بدانید',
      adTitle: 'تبلیغ',
      skipOn: seconds => `رد کردن تبلیغ بعد از ${seconds} ثانیه`,
      skip: 'رد کردن تبلیغ',
    };
  }

  render() {
    const { onSkip, onLinkClick, duration, skipOn, URL } = this.props;

    return duration >= 0 ? <div className="react-video-ad-content">
      <div className="react-video-ad-description">
        {URL &&
        <a onClick={() => onLinkClick()} className="ad-actions ad-read-more"
           href={URL} target="_blank" rel="nofollow">
          <svg width="20px" height="20px" viewBox="0 0 24 24">
            <path fill="#ffffff"
                  d="M15.7,13c-1,0-1.2,0.8-1.2,1v2.4c0,0.2-0.2,0.4-0.4,0.4H8c-0.2,0-0.4-0.2-0.4-0.4v-6C7.6,10.2,7.8,10,8,10h1.9c0.6,0,1.1-0.5,1.1-1.1v0c0-0.6-0.5-1.1-1.1-1.1h-3c-0.8,0-1.5,0.7-1.5,1.5v8.2c0,0.8,0.7,1.5,1.5,1.5h8.4c0.8,0,1.5-0.7,1.5-1.5L16.7,14C16.7,13,15.7,13,15.7,13z"/>
            <path fill="#ffffff"
                  d="M19,12.1l0-6C19,5.5,18.5,5,17.9,5l-6,0c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h3.3l-6,6c-0.4,0.4-0.4,1.2,0,1.6s1.2,0.4,1.6,0l6-6v3.3c0,0.6,0.5,1.1,1.1,1.1C18.5,13.3,19,12.7,19,12.1z"/>
          </svg>
          {this.adsActionsTitle.readMore}
          <span> • </span>
          ثانیه {duration} :{this.adsActionsTitle.adTitle}
        </a>}
      </div>

      {skipOn !== null && <div
        className={`ad-actions ad-skip ${skipOn > 0 ? 'ad-skip-on' : ''}`}
        onClick={() => {
          if (skipOn <= 0) {
            onSkip();
          }
        }
        }>
        {skipOn > 0 ? this.adsActionsTitle.skipOn(skipOn) : this.adsActionsTitle.skip}
      </div>}
    </div> : null;
  }
}

// AdControllers.propTypes = propTypes;
AdControllers.displayName = 'AdControllers';
